module.exports = __webpack_public_path__ + "static/1028900652-wide.797d487e.jpg";